import { Component, OnInit, TemplateRef, Input, Output, EventEmitter, Renderer2, ViewChildren, QueryList } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { ToastService } from '../../shared/providers/toast.service';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { IDashboardOModel, IExchangeInvites, IExchangeInvitesList } from '../../shared/models/DashboardDataOModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { LoaderService } from '../../shared/providers/loader.service';
import { RestService } from '../../shared/providers/rest.service';
import { Router } from '@angular/router';
import { catchError, debounceTime, distinctUntilChanged, Observable, of, Subject, switchMap, tap } from 'rxjs';
import { CommonService } from '../../shared/providers/common.service';
import { MatSelect } from '@angular/material/select';

export enum Permissions {
  ReadOnly = 2400,
  FullControl = 2401
}
@Component({
  selector: 'app-exchange-1031-invite',
  templateUrl: './exchange-1031-invite.component.html'
})
export class Exchange1031InviteComponent implements OnInit {
  @Input() modalRefinvite: BsModalRef;
  dataService: [];/*CompleterData;*/
  constructor(private _trade1031Service: Trade1031Service, private renderer: Renderer2,
    private Authentication: AuthenticationService,
    public _validationService: ValidationService,
    private modalService: BsModalService,/* private completerService: CompleterService, */private Toast: ToastService, private _restService: RestService, private router: Router,
    private Loader: LoaderService, private _commonService: CommonService) {
    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/common/principalListByEmailAutoComplete/', 'Name', 'Name');
    //remoteDataProvider.urlFormater(x => {
    //    return encodeURI(_restService.getBaseUrl + '/common/principalListByEmailAutoComplete/' + x + "/" + this.LoggedInUser.Id);
    //});
    //this.dataService = remoteDataProvider;
  }
  @Input() selectedExchange: number = 0;
  @Output() close = new EventEmitter();
  @Output() reload = new EventEmitter();
  LoggedInUser: any;
  @ViewChildren(MatSelect) matSelects!: QueryList<MatSelect>;
  ngOnInit() {
    this.LoggedInUser = this.Authentication.user;
    this.clearInviteeModel();
    this.loadItems();
  }
  ngAfterViewInit() {
    this.matSelects.forEach((matSelect) => {
      matSelect.openedChange.subscribe((isOpened) => {
        if (isOpened) {
          this.addClassToOverlayContainer();
        } else {
          this.removeClassFromOverlayContainer();
        }
      });
    });
  }
  addClassToOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.addClass(overlayContainer, 'custom-overlay-container');
    }
  }

  removeClassFromOverlayContainer() {
    const overlayContainer = document.querySelector('.cdk-overlay-container');
    if (overlayContainer) {
      this.renderer.removeClass(overlayContainer, 'custom-overlay-container');
    }
  }
  dataService$: Observable<any[]>;
  dataServiceInput$ = new Subject<string>();
  loading = false;

  private loadItems() {
    this.dataService$ = this.dataServiceInput$.pipe(
      distinctUntilChanged(),
      debounceTime(300),
      tap(() => this.loading = true),
      switchMap(term => this.getItems(term).pipe(
        catchError(() => of([])), // empty list on error
        tap(() => this.loading = false)
      ))
    )
  }

  getItems(term: any = null): Observable<any[]> {
    return this._commonService.principalListByEmailAutoComplete(term, this.LoggedInUser.Id);

  }
  modalRef: BsModalRef;
  ExchangeInvitesList: IExchangeInvitesList[];
  openModal(template: TemplateRef<any>, classes) {
    this.clearInviteeModel();
    this.modalRef = this.modalService.show(template, { class: classes });
  }
  clearInviteeModel() {
    this.invalidEmail = false;
    this.inviteEmailAddress = "";
    this.loadInvitees();
    this.ExchangeInvites.PermissionId = this.Permissions.ReadOnly;
  }
  loadInvitees() {
    this._trade1031Service.GetExchangeInvitees(this.selectedExchange).subscribe(res => {
      this.ExchangeInvitesList = res;
      this.ExchangeInvitesList.forEach(item => {
        item.Date = this._validationService.convertUTCDateToLocalDate(item.Date);
      });
    });
  }

  showPrincipalDtls = false;
  inviteEmailAddress;
  invalidEmail = false;
  onPrincipalSelect($event) {
    if ($event !== null) {
      this.showPrincipalDtls = true;
      this.inviteEmailAddress = $event;
    }
  }
  validationMsg = "";
  ExchangeInvites = {} as IExchangeInvites;
  onInvite() {
    if (this._validationService.IsinValid(this.inviteEmailAddress)) {
      this.invalidEmail = true;
      this.validationMsg = "Email Id is required";
    }
    else if (!this._validationService.isEmail(this.inviteEmailAddress)) {
      this.invalidEmail = true;
      this.validationMsg = "Invalid Email Id";
    }
    else {
      this.Loader.display(true);
      this.ExchangeInvites.EmailId = this.inviteEmailAddress;
      this.ExchangeInvites.ExchangeId = this.selectedExchange;
      this.ExchangeInvites.LoggedInUserId = this.LoggedInUser.Id;
      this._trade1031Service.SaveExchangeInvite(this.ExchangeInvites).subscribe(res => {
        if (res.IsSuccess) {
          this.clearInviteeModel();
          this.reload.emit(true);
          this.Toast.addToast({ title: 'Success', msg: 'Invite Sent Successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          //this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
        }
        else {
          this.Toast.addToast({ title: 'Error Occurred', msg: res.ErrorMessage, timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        this.Loader.display(false);
      });
    }
  }
  ClearValidation() {
    this.invalidEmail = false;
    if (this._validationService.IsinValid(this.inviteEmailAddress)) {
      this.invalidEmail = true;
      this.validationMsg = "Email Id is required";
    }
  }
  ConfirmInvitees(template: TemplateRef<any>, classes) {
    this.ExchangeInvites.PermissionId = this.Permissions.ReadOnly;
  }
  Permissions = Permissions;
  onPermissionChange(PermissionId) {
    this.ExchangeInvites.PermissionId = PermissionId;
  }

  idToRemoveInvitee = 0;
  onRemoveInvitee(template: TemplateRef<any>, classes, id) {
    this.idToRemoveInvitee = id;
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  closeThisModal() {
    this.close.emit(true);
    this.modalRefinvite.hide();
  }

  removeInvitee() {
    this._trade1031Service.DeleteInviteeFromExchange(this.idToRemoveInvitee, this.LoggedInUser.Id).subscribe(res => {
      if (res) {
        this.loadInvitees();
        this.modalRef.hide();
        this.reload.emit(true);
        this.Toast.addToast({ title: 'Success', msg: 'Invite Removed Successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        //this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Error while removing invitee.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }
  onPermissionsChange(id, permission) {
    this._trade1031Service.ChangeInvitePermission(id, permission).subscribe(res => {
      if (res) {
        this.loadInvitees();
        this.Toast.addToast({ title: 'Success', msg: 'Permission Changed Successfully.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: 'Error while changing permission.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });
  }
  onClose($event) {
    this.close.emit(true);
  }
}
